//import logo from './logo.svg';
//import './App.css';
import Router from './routes'
import ThemeProvider from './theme';
import { MotionLazyContainer } from './components/animate';
import SnackbarProvider from './components/snackbar';
import { LocalizationProvider  } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

/**
 * This is a React component that renders a container with motion effects, a theme provider, a
 * localization provider, a snackbar provider, and a router.
 * @returns The `App` function is returning a JSX expression that includes a `MotionLazyContainer`
 * component, a `ThemeProvider` component, a `LocalizationProvider` component with a `dateAdapter` prop
 * set to `AdapterMoment`, a `SnackbarProvider` component, and a `Router` component.
 */
function App() {
  return (
    <> 
      <MotionLazyContainer>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <SnackbarProvider>
              <Router />
            </SnackbarProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </MotionLazyContainer>
    </>
  );
}

export default App;
